module.exports = __webpack_public_path__ + "static/media/mainbg_app.ba095b56.png";